import PropTypes from 'prop-types';

export default function Emote(props) {
	const classes = ['blog-feedback__rating-btn'];

	props.value === props.selection && classes.push('blog-feedback__rating-btn--selected');

	return (
		<div id={props.value} onClick={() => (props.selection === '' ? props.submitVote(props.value) : '')} className={classes.join(' ')}>
			{props.selection !== '' && <span className="h6">{props.count}</span>}
		</div>
	);
}

Emote.propTypes = {
	selection: PropTypes.string,
	count: PropTypes.number,
	submitVote: PropTypes.func,
	value: PropTypes.string,
};
